<template>
  <div class='settings-view'>

    <div class="settings-panel" v-if="cart.delivery.shipping">
      <div class='page-form-field-instance'>
        <div class='page-form-field-wrap'>

          <div class='page-form-field-outer'>

            <!-- Days -->
            <day-picker-panel @plan-picked="calendarChanged" :methodCode="code"/>

            <!-- Available Slots -->
            <div class='day-slots-wrap'>
            <slot-panel v-for="(slotItem, index) in showingSlots"
                        :data="slotItem"
                        :order="index"
                        :methodCode="code"
                        :selectable="slotItem.remaining >= 0 && slotItem.stopInFuture"
                        @slot-selected="slotSelected" />
            </div>

            <!-- Day information -->
            <div class='remaining-time' v-if="infoText">
              <p>{{infoText}}</p>
            </div>

            <div class="" v-if="cart.processingError == 'MISSING_DELIVERY_PRICE'">Chyba, vyberte zde něco</div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import DayPickerPanel from './planning/DayPickerPanel'
  import SlotPanel from './planning/SlotPanel'
  import Cart from '@/cart'
  import Langs from '@/langs'
  import Utils from '@/utils'

  export default {
    props: ['cart', 'shopData', 'code'],
    components: {
      DayPickerPanel,
      SlotPanel
    },
    data() {
      return {
        pickedPlan: null,
        planData: null,
        showingSlots: [],
        infoText: '',
        lastTime: null,
        slotInfoCheckTimeoutSet: false
      }
    },
    created() {
      console.log('CustomDeliveryPlanning::created', this.cart, this.shopData, this.code)

      // Setting this to NULL means, it is required.
      // The delivery will not have the attribute in any other case
      // delete this.cart.delivery['slot']
      // Vue.set(this.cart.delivery, 'slot', null)
    },
    beforeDestroy() {
      this.lastTime = null
    },
    methods: {
      isAnySlotAvailableOnSelectedDay() {
        let available = false
        this.showingSlots.forEach(slot => {
          if (slot.remaining >= 0) {
            available = true
          }
        })
        return available
      },
      slotSelected(slot) {
        this.showingSlots.forEach(s => {
          console.log('Marking selected slots', s.selected, s.mark == slot.mark)
          s.selected = s.mark == slot.mark
          if (s.selected) {
            let minutesLeft = (s.validUntil.getTime() - (new Date()).getTime()) / 60000
            if (minutesLeft > 0 && minutesLeft < 120) {
              this.infoText = Langs.get('delivery-slots-info', [Math.ceil(minutesLeft)])
            }
          }
        })

        // TODO: unhardcode this
        let price = {
          brutto: slot.price,
          vat_pct: 21,
        }
        var vat = (((price.brutto !== null) ? price.brutto : price.incl_vat) / (price.vat_pct + 100)) * price.vat_pct
        var netto = ((price.brutto !== null) ? price.brutto : price.incl_vat) - vat
        netto = Math.round(netto * 100) / 100
        let slotDetails = {
          id: slot.id,
          mark: slot.mark,
          validUntil: slot.validUntil,
          methodCode: slot.methodCode,
          price: {
            brutto: slot.price,
            netto: netto,
            vat_pct: price.vat_pct,
            currency: 'CZK'
          }
        }
        delete this.cart.delivery['slot']
        Vue.set(this.cart.delivery, 'slot', slotDetails)
        // console.log('Slot selected', slotDetails, this.cart.delivery)
        this.$emit('selected')
      },
      calendarChanged(planData) {
        console.log('Calendar changed', planData)
        this.planData = planData
        if (planData.initial == false) {
          console.log('Clearing slot')
          delete this.cart.delivery['slot']
          Vue.set(this.cart.delivery, 'slot', null)
        }
        this.showingSlots.splice(0)
        planData.plan.slots.forEach(s => {
          if (Cart.data.delivery.slot && Cart.data.delivery.slot.mark) {
            s.selected = Cart.data.delivery.slot.mark == s.mark
          } else {
            s.selected = false
          }
          if (s.enabledFor === undefined || s.enabledFor.includes(this.code)) {
            this.showingSlots.push(s)
          }
        })

        // Clacluate the information for tomorrow
        let tomorrow = (new Date()).addDays(1)
        if (tomorrow.yyyymmdd() == planData.plan.date.yyyymmdd()) {
          let hm = Utils.getPlanCloseTime(planData.plan, Cart.shopData)
          if (hm.length == 2) {
            this.lastTime = new Date()
            this.lastTime.setHours(hm[0])
            this.lastTime.setMinutes(hm[1])
            this.lastTime.setSeconds(0)
          }
          this.updateInfoText()
        } else {
          this.lastTime = null
          this.updateInfoText()
        }

      },
      updateInfoText() {
        this.checkInfoText()
        Utils.setTimer('delivery-info-text', this.checkInfoText, 5)
      },
      checkInfoText() {
        // console.log('Running updateInfoText', this.planData.plan.date)
        if (this.isAnySlotAvailableOnSelectedDay()) {
          let allInPast = true
          // Check every slot.
          // console.log('Checking plan', this.planData.plan.slots)
          this.infoText = ''
          this.planData.plan.slots.forEach(s => {
            if (s.enabledFor != this.code) {
              return
            }
            let minutesLeft = (s.validUntil.getTime() - (new Date()).getTime()) / 60000
            if ((minutesLeft <= 0 || minutesLeft > 120) && s.selected) {
              this.infoText = ''
              this.lastTime = null
              // console.log('Hiding text')
            }
            s.stopInFuture = minutesLeft > 0

            // console.log(`Minutes left ${s.mark}`, s.selected, minutesLeft, s.stopInFuture ? 'slot is active' : 'slot is not active ' + s.mark)

            allInPast = allInPast && !s.stopInFuture
            // console.log('>', allInPast, s.stopInFuture)

            if (s.selected && !s.stopInFuture) {
              this.deselect()
            } else if (s.selected && minutesLeft > 0 && minutesLeft < 120) {
              this.infoText = Langs.get('delivery-slots-info', [Math.ceil(minutesLeft)])
              // console.log('Showing text')
            }
          })

          // Of no slot available, show the info
          if (allInPast) {
            // console.log('All slots in past, disable all day')
            // the time is up for today, remove any selected slot, if was already selected
            // this.calendarChanged(planData)
            this.infoText = 'Na tento den už toho máme až nad hlavu! Zkuste, prosím, další :)'
            // planData.plan.slots.forEach(s => {
            //   s.remaining = -1
            // })
            this.deselect()
          }
          //
          // // Repeat after one minute
          // if (!this.slotInfoCheckTimeoutSet) {
          //   this.slotInfoCheckTimeoutSet = true
          //   setTimeout(() => {
          //     this.slotInfoCheckTimeoutSet = false
          //     this.updateInfoText()
          //   }, 5000);
          // }
        } else {
          this.infoText = 'Na tento den už toho máme až nad hlavu! Zkuste, prosím, další :)'
        }
      },
      deselect() {
        if (this.cart.delivery['slot']) {
          delete this.cart.delivery['slot']
          Vue.set(this.cart.delivery, 'slot', null)
          this.$emit('selected')
        }
      },
      getSlotTime(slot) {
        if (slot) {
          return this.getTimeHHMM(slot.from) + this.getTimeHHMM(slot.to)
        }
        return '00000000'
      },
      getTimeHHMM(time) {
        if (time) {
          return time.replace(/\,/g,'')
        }
        return '0000'
      },
    }
  }
</script>

<style lang='less' scoped>
@import '../../../variables.less';

.day-slots-wrap {
  padding-top: 90px;
}

.remaining-time {
  padding: 10px;

  p {
    font-size: 0.875rem;
    text-align: center;
    color: @pfm-cart-color-form-switch-text-secondary;
  }
}
</style>
